<app-card [borderStyle]="'shadow'">
  @if (!areAllParticipantsCheckedIn) {
    <div class="card-content">
      <h1 class="card-content__heading">Welcome to your digital signing</h1>
      <p class="card-content__subtext">
        {{ subHeading }}
      </p>
      <app-button [type]="'primary'" [dataTestId]="'next-button-landing'" (buttonClick)="beginCheckIn()">
        Begin Check-in
      </app-button>
    </div>
  } @else {
    <div class="card-content">
      <h1 class="card-content__heading">Welcome back to your digital signing</h1>
      <p class="card-content__subtext">
        When you're ready, click "Enter" below to enter signing room.
      </p>
      <app-button [type]="'primary'" [dataTestId]="'next-button-landing-enter'" (buttonClick)="enter()">
        Enter
      </app-button>
    </div>
  }

</app-card>

<img
  class="welcome-page-image"
  data-testid="landing-pic"
  src="assets/images/welcome-home.svg"
  alt=""
  />
  <app-package-status-monitor></app-package-status-monitor>
